import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy, TruncatedCopy } from '../../../preview-common/meta-preview-copy';

/**
 * Facebook profile feed (mobile). The mobile feed post with the desktop-style
 * link bar: the domain over the headline, and a full-size button.
 */
@Component({
  selector: 'app-meta-facebook-profile-feed',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './facebook-profile-feed.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../../preview-common/facebook/facebook-feed-styles.scss',
    './facebook-profile-feed.component.scss',
  ]
})
export class MetaFacebookProfileFeedPreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly pageName = MetaPreviewCopy.FACEBOOK_PAGE_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  /** Same rule as the mobile feed: the first paragraph, up to 125 characters. */
  get primaryText(): TruncatedCopy {
    return MetaPreviewCopy.firstParagraph(MetaPreviewCopy.primaryText(this.data), 125);
  }

  get headline(): string {
    return MetaPreviewCopy.headline(this.data);
  }

  get domain(): string {
    return MetaPreviewCopy.domain(this.data);
  }

  get cta(): string {
    return MetaPreviewCopy.cta(this.data);
  }
}
